var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('StatisticsCard',{attrs:{"title":_vm.title,"totalNumber":_vm.totalNumber,"icon":_vm.icon,"data":_vm.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }